// extracted by mini-css-extract-plugin
export default {"-large":"TfvjOh_jG_OPrK3iitAg","header":"AxzLJXXpstEQGcFSBPCu"};